import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

const Body = ({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) => (
  <h4 className={classNames('body-m-reg', className)} {...rest} />
);

export default Body;
